import { render, staticRenderFns } from "./formGraduateInternship.vue?vue&type=template&id=505eca4c&scoped=true&"
import script from "./formGraduateInternship.vue?vue&type=script&lang=js&"
export * from "./formGraduateInternship.vue?vue&type=script&lang=js&"
import style0 from "./formGraduateInternship.vue?vue&type=style&index=0&id=505eca4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505eca4c",
  null
  
)

export default component.exports